<section class="popup-page">
  <header>
    <button type="button" class="icon-button" (click)="back()" [attr.aria-label]="'PROFILE_POPUP_BACK' | translate">&#8249;</button>
    <div class="title">
      <span class="user-name">{{ userName }}</span>
      <h2>{{ 'PROFILE_POPUP_ADD_ACCESS' | translate }}</h2>
    </div>
    <button type="button" class="icon-button" (click)="close()" [attr.aria-label]="'CLOSE' | translate">&#215;</button>
  </header>
  <h3>{{ 'ASSIGN_ACCESS' | translate }}</h3>

  <div *ngIf="hasUnits" class="search-row">
    <app-search-field class="search" (searchCriteria)="search($event)"></app-search-field>
    <button type="button" class="filter-button" (click)="openFilter()" [attr.aria-label]="'FILTER_UNITS' | translate">
      <img src="assets/svg/ico-filter-circle-outline-white.svg" alt="" />
      <span *ngIf="filterCount" class="filter-badge">{{ filterCount }}</span>
    </button>
  </div>

  <p *ngIf="hasUnits" class="building-name" [title]="building?.buildingName">{{ building?.buildingName }}</p>

  <div class="unit-list" role="group" [attr.aria-label]="building?.buildingName">
    <p *ngIf="!hasUnits" class="empty" role="status">{{ 'NO_UNIT_IN_THIS_BUILDING' | translate }}</p>
    <p *ngIf="hasUnits && !visibleFloors.length" class="empty" role="status">
      {{ 'NO_FLOORS_AVAILABLE_FOR_APPLIED_FILTER' | translate }}
    </p>
    <ng-container *ngFor="let floor of visibleFloors">
      <div class="floor-header">
        <img src="assets/svg/ico-floor.svg" alt="" aria-hidden="true" />
        <span class="floor-name" [title]="floor.floorName">{{ floor.floorName }}</span>
        <span *ngIf="floor.wingName" class="wing-name" [title]="floor.wingName">
          {{ floor.wingName }} - {{ 'WING' | translate }}
        </span>
      </div>
      <button
        *ngFor="let unit of floor.units"
        type="button"
        class="unit"
        role="checkbox"
        [class.selected]="isSelected(unit)"
        [attr.aria-checked]="isSelected(unit)"
        (click)="toggleUnit(unit)"
      >
        <span class="unit-icon" aria-hidden="true">
          <img src="assets/svg/ico-default-home.svg" alt="" />
        </span>
        <span class="unit-name" [title]="unit.label">{{ unit.label }}</span>
        <span class="radio" aria-hidden="true">
          <mat-icon *ngIf="isSelected(unit)">check</mat-icon>
        </span>
      </button>
    </ng-container>
  </div>

  <button type="button" class="primary-button" [disabled]="!selectedUnits?.length" (click)="continue()">
    {{ 'CONTINUE' | translate }}
  </button>
</section>
